module.exports = __webpack_public_path__ + "static/media/Investor-FULL BRUNSWICK PRESENTATION V4_1646507760957.d547e372.vtt";